import React, { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';

import { ITINERARIES_ITEM_TYPE_TO_KEY_MAP } from 'store/admin/itineraries';
import { itinerariesItemDataSelector } from 'store/itinerariesItem/selectors';
import axios from 'utils/axios';
import { getBaseRoute } from 'utils/filesDownloaders/docx';
import { decamelizeKeys, decamelize } from 'utils/humps';

function SaveAsWordDoc() {
  const docRef = useWordDoc();

  return <span ref={docRef}>Save as Word Doc</span>;
}

export default SaveAsWordDoc;

function useWordDoc() {
  const ref = useRef(null);
  const item = useSelector(itinerariesItemDataSelector);

  useEffect(() => {
    if (!ref.current) return;

    const link = document.createElement('a');
    link.innerText = 'View as JSON';
    link.style = 'font-size: 10px; margin-left: 5px; color: grey';
    link.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();

      const proposalRouteName = decamelize(ITINERARIES_ITEM_TYPE_TO_KEY_MAP[item.type]);
      const queue = `${getBaseRoute()}/${proposalRouteName}/${item.id}/files/docx`;

      axios.get(queue).then(({ data }) => {
        const newWindow = window.open('', 'JSON');
        newWindow.document.body.innerHTML = `${JSON.stringify(decamelizeKeys(data))
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')}`;
      });
    });

    const altDownListener = (evt) => {
      if (evt.key !== 'Alt') return;

      ref.current.appendChild(link);
    };

    const altUpListener = (evt) => {
      if (evt.key !== 'Alt') return;

      ref.current.removeChild(link);
    };

    document.addEventListener('keydown', altDownListener);
    document.addEventListener('keyup', altUpListener);

    return () => {
      document.removeEventListener('keydown', altDownListener);
      document.removeEventListener('keyup', altUpListener);
    };
  }, []);

  return ref;
}
